module.exports = __webpack_public_path__ + "img/img6.eab0ef55.jpg";